module.exports = __webpack_public_path__ + "static/media/3dbazaar_logo_big.e095e5c5.svg";